export const TABLE_EMPLOYEE_INDEX = {
  EmployeeID: "memid",
  Status: "status",
  Name: "name",
  CoName: "coid",
  IC: "ic",
  Group: "groupName",
  Salary: "baseSal",
  Amount: "eligAmount",
  Contact: "contact",
  Loyalty: "loyaltyTier",
  AppFreq: "pr_freq",
  Bank_Name: "bank_name",
  Bank_Acc: "bank_acc",
  bank_holder_name: "bank_holderName",
  bank_holder_ic: "bank_holderIc",
  Reference: "empRefID",
  CreatedAt: "createdAt",
  UpdatedAt: "updatedAt",
  Remarks: "remark",
  Position: "position",
};

export const TABLE_EMPLOYEE_TITLE = {
  EmployeeID: "Employee ID",
  Status: "Status",
  Name: "Employee Name",
  CoName: "Company Name",
  CoID: "Company ID",
  IC: "IC Number",
  Group: "Group",
  Owning: "Owning",
  Amount: "Eligible Amount",
  Salary: "Base Salary",
  Contact: "Contact",
  Loyalty: "Loyalty",
  AppFreq: "Application Frequency",
  Bank_Name: "Bank Info",
  BankName: "Bank Name",
  BankAcc: "Bank Account",
  BankHolderName: "Bank Holder Name",
  BankHolderIC: "Bank Holder IC",
  Reference: "Employee Reference ID",
  CreatedAt: "Created By",
  UpdatedAt: "Last Updated By",
  Remarks: "Remarks",
};

export const EMPLOYEE_STATUS = {
  created: 1,
  active: 2,
  suspended: 3,
  terminated: 0,
};

export const EMPLOYEE_STATUS_TITLE = {
  [EMPLOYEE_STATUS.created]: {
    name: "Created",
    colorTag: "#959595",
    bgColor: "#F5F5F5",
    status: 1,
  },
  [EMPLOYEE_STATUS.active]: {
    name: "Active",
    colorTag: "#34C759",
    bgColor: "#DDFFE4",
    status: 2,
  },
  [EMPLOYEE_STATUS.suspended]: {
    name: "Suspended",
    colorTag: "#FFA800",
    bgColor: "#FFF5E0",
    status: 3,
  },
  [EMPLOYEE_STATUS.terminated]: {
    name: "Terminated",
    colorTag: "#FF0000",
    bgColor: "#FFF2F2",
    status: 0,
  },
};

export const TABLE_EMPLOYEE_TITLE_BULK = {
  [TABLE_EMPLOYEE_INDEX.Name]: "Employee Name*",
  [TABLE_EMPLOYEE_INDEX.IC]: "IC Number*",
  [TABLE_EMPLOYEE_INDEX.Position]: "Position*",
  [TABLE_EMPLOYEE_INDEX.Contact]: "Phone Number*",
  [TABLE_EMPLOYEE_INDEX.Salary]: "Base Salary",
  [TABLE_EMPLOYEE_INDEX.Amount]: "Eligible Amount*",
  [TABLE_EMPLOYEE_INDEX.CoName]: "Company ID*",
  [TABLE_EMPLOYEE_INDEX.Bank_Name]: "Bank Name*",
  [TABLE_EMPLOYEE_INDEX.Bank_Acc]: "Bank Account*",
  [TABLE_EMPLOYEE_INDEX.bank_holder_name]: "Bank Holder Name*",
  [TABLE_EMPLOYEE_INDEX.bank_holder_ic]: "Bank Holder IC*",
  [TABLE_EMPLOYEE_INDEX.Reference]: "Employee Reference ID"
};

export const TABLE_BULK_UPLOAD_INDEX = [
  [TABLE_EMPLOYEE_INDEX.Name],
  [TABLE_EMPLOYEE_INDEX.IC],
  [TABLE_EMPLOYEE_INDEX.Position],
  [TABLE_EMPLOYEE_INDEX.Contact],
  [TABLE_EMPLOYEE_INDEX.Salary],
  [TABLE_EMPLOYEE_INDEX.Amount],
  [TABLE_EMPLOYEE_INDEX.CoName],
  [TABLE_EMPLOYEE_INDEX.Bank_Name],
  [TABLE_EMPLOYEE_INDEX.Bank_Acc],
  [TABLE_EMPLOYEE_INDEX.bank_holder_name],
  [TABLE_EMPLOYEE_INDEX.bank_holder_ic],
  [TABLE_EMPLOYEE_INDEX.Reference]
];

export const EMPLOYEE_MANAGEMENT_TITLE_BY_NAME = Object.fromEntries(
  Object.keys(TABLE_EMPLOYEE_TITLE_BULK).map((k) => [
    TABLE_EMPLOYEE_TITLE_BULK[k],
    k,
  ])
);

const TABLE_BULK_UPLOAD_INDEX_OBJ_ENTRIES = Object.fromEntries(
  TABLE_BULK_UPLOAD_INDEX
);

export const TABLE_BULK_UPLOAD_INDEX_EMPTY_STRINGS = Object.fromEntries(
  Object.entries(TABLE_BULK_UPLOAD_INDEX_OBJ_ENTRIES).map(([key, value]) => [
    key,
    value || "",
  ])
);

export const EMPLOYEE_FAIL_REASON = {
  MISSING: 'Missing data',
  INVALID: 'Invalid data format',
  INCOMPLETE: 'Incomplete Data', 
  WRONGFORMAT1: "IC Number wrong format",
  WRONGFORMAT2: "Bank Holder IC wrong format",
  EXIST: 'Company ID does not exist',
  TOO_SHORT: "Phone number is too short",
  EXIST_PHONE: 'The phone number is already registered in the system',
  DUPLICATED_PHONE: 'Duplicated Phone number',
  EXIST_IC: 'The IC number is already registered in the system',
  DUPLICATED_IC: 'Duplicated Phone number',
}

export const EMPLOYEE_INDEX = {
  name: "name",
  ic: "ic",
  position: "position",
  contact: "contact",
  baseSal: "baseSal",
  eligAmount: "eligAmount",
  coid: "coid",
  bank_name: "bank_name",
  bank_acc: "bank_acc",
  bank_holderName: "bank_holderName",
  bank_holderIc: "bank_holderIc",
  empRefID: "empRefID",
  
};

export const filterOptions = (user) => {
  let selectOptions;

  if (user === "A") {
    selectOptions = [
      { value: "createdAt", label: "Created date", type: "date" },
      { value: "memid", label: "Employee ID", type: "text" },
      { value: "name", label: "Employee name", type: "text" },
      { value: "coid", label: "Company ID", type: "text" },
      { value: "company_name", label: "Company name", type: "text" },
      { value: "ic", label: "Employee IC", type: "text" },
      { value: "contact", label: "Contact number", type: "text" },
      { value: "groupid", label: "Employee Group", type: "select" },
      { value: "reference", label: "Reference ID", type: "text" },
    ];
  } else {
    selectOptions = [
      { value: "createdAt", label: "Created Date", type: "date" },
      { value: "memid", label: "Employee ID", type: "text" },
      { value: "name", label: "Employee Name", type: "text" },
      { value: "ic", label: "IC Number", type: "text" },
      { value: "contact", label: "Contact Number", type: "text" },
      { value: "refid", label: "Reference ID", type: "text" },
      { value: "groupid", label: "Employee Group", type: "select" },
    ];
  }

  return selectOptions;
};

export const groupOptions = (group) => {
  const groupOptions = group
    ? Object.values(group).map((g) => ({
        value: g.groupid,
        label: g.name,
      }))
    : [];

  return groupOptions;
};
